import './App.css';
import Pages from './pages/page';

function App() {
  return (
    <div className="App">
    <Pages />
    </div>
  );
}

export default App;
